import { createSlice } from "@reduxjs/toolkit"
import { getDashboardData } from "store/actions/dashboardAction"

const initialState = {
  isLoading: false,
  loading: false,
  dashboardData: [],
}

const dashboardSlice = createSlice({
  name: "Dashboard",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getDashboardData.pending, state => {
        state.loading = true
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          state.dashboardData = data
        }
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default dashboardSlice.reducer
